<template>
	<div>
		<label class="label">{{label}}</label>
		<v-menu
			ref="menu"
			v-model="menu"
			:nudge-right="40"
			lazy
			transition="scale-transition"
			offset-y
			full-width
			max-width="290px"
			min-width="290px"
			:readonly="readonly"
			:disabled="readonly"
			class="date-picker-input"
		>
			<v-text-field
				slot="activator"
				:label="label"
				persistent-hint
				append-icon="event"
				solo
				:placeholder="placeHolder"
				:readonly="readonly"
				:disabled="readonly"
				:value="dateFormatted"
				class="text-field select-app"
			></v-text-field>
			<v-date-picker
				locale="es"
				:value="date"
				no-title
				:max="maxDate"
				:min="minDate"
				:readonly="readonly"
				:disabled="readonly"
				@input="sendDate"
			></v-date-picker>
		</v-menu>
	</div>
</template>

<script>
import { format } from 'date-fns';

function formatDate(d) {
	if (!d) {
		return null;
	}
	const [year, month, day] = d.split('-');
	return `${month}/${day}/${year}`;
}
function parseDate(d) {
	if (!d) {
		return null;
	}
	const result = format(d, 'YYYY-MM-DD');
	if (result === 'Invalid Date') {
		const [day, month, year] = d.split('/');
		const resulD = `${year}-${month}/${day}`;
		return format(resulD, 'YYYY-MM-DD');
	}
	return result;
}
function dateFormatted(newValue) {
	this.date = this.parseDate(newValue);
}
function sendDate(date) {
	this.menu = false;
	const newDate = this.formatDate(date);
	const body = { value: newDate, model: this.model };
	this.$emit('input', body);
}
function data() {
	return {
		date: '',
		menu: false,
	};
}
export default {
	name: 'app-date-select',
	data,
	methods: {
		formatDate,
		parseDate,
		sendDate,
	},
	props: {
		dateFormatted: {
			type: [Date, String, Number],
		},
		label: {
			default: '',
			type: String,
		},
		maxDate: [Date, String],
		minDate: {
			type: [Date, String],
		},
		model: {
			type: String,
		},
		placeHolder: {
			type: String,
		},
		readonly: {
			default: false,
			type: Boolean,
		},
	},
	watch: {
		dateFormatted,
	},
};
</script>

<style lang="scss" scoped>
.label {
	font-size: size(small);
}
.text-field {
	border: 1px solid rgba(0, 0, 0, 0.1);
	border-radius: 3px;
	padding-left: 16px;
	position: relative;
}
</style>


// WEBPACK FOOTER //
// src/components/shared/date-component.vue